import { type ContactListInput, type ContactListSuccess, type ContactData } from '@terros/common'
import { useTantalimInfiniteQuery, type GetInfiniteHookResponse } from '../infiniteQuery'
import { contactInfiniteKey } from './keys'

export function useInfiniteContacts(input: ContactListInput): GetInfiniteHookResponse<ContactData> {
  return useTantalimInfiniteQuery<ContactListInput, ContactListSuccess, ContactData>({
    url: '/contact/list',
    queryKey: contactInfiniteKey(input),
    input,
    selectRecords: (page) => page.contacts,
    options: { refetchOnMount: true },
  })
}
